import { sva } from "styled-system/css";

export const recurringEventsRecipe = sva({
  slots: [
    "mainContainer",
    "scrollContainer",
    "eventGroups",
    "scrollForMore",
    "emptyState",
  ],
  base: {
    mainContainer: {
      h: "532px",
      position: "relative",
    },
    scrollContainer: {
      flexDir: "column",
      h: "532px",
      gap: "20px",
      overflowY: "auto",
      paddingBottom: "200",
    },
    eventGroups: {
      flexDir: "column",
      gap: "150",
    },
    scrollForMore: {
      alignItems: "center",
      gap: "150",
      bottom: 0,
      w: "full",
      position: "absolute",
      pt: "400",
      pb: "150",
      background:
        "linear-gradient(3deg, white 63.04%, rgba(239, 238, 235, 0.00) 97.82%)",
      zIndex: "1",
      transition: "all ease-in-out 150ms",
      opacity: 0,
      visibility: "hidden",
      '&[data-has-overflow="true"]': {
        opacity: 1,
        visibility: "visible",
      },
      '&[data-at-end="true"]': {
        opacity: 0,
        visibility: "hidden",
      },
    },
    emptyState: {
      h: "532px",
      mb: "-16px",
      backgroundColor: "bg.lightest",
    },
  },
  variants: {
    size: {
      mobile: {
        mainContainer: {
          h: "auto",
        },
        scrollContainer: {
          h: "auto",
        },
        emptyState: {
          h: "auto",
          mb: "0",
        },
      },
      tablet: {},
      desktop: {},
      large: {},
    },
  },
  defaultVariants: {
    size: "mobile",
  },
});
